/**
 * Created by vladislav on 28.07.20.
 */

const HintView = cc.Node.extend({
    ctor: function (hint) {
        this.hint = hint;

        this._super();
        this.setAnchorPoint(0.5, 0.5);
        this.setVisible(false);

        this.createBg();

        this.onResize();
    },

    createBg: function () {
        const bg = this.bg = cleverapps.UI.createScale9Sprite(bundles.game.frames.theme_bg_png, cleverapps.UI.Scale9Rect.TwoPixelXY);
        this.addChild(bg);
        bg.setLocalZOrder(-1);
        bg.setAlignment(cleverapps.styles.HintView.bg);
    },

    createText: function () {
        if (this.text) {
            this.text.removeFromParent();
        }

        const styles = cleverapps.styles.HintView;

        const text = this.text = cleverapps.UI.generateTTFText(this.hint, cleverapps.styles.FONTS.HINT_TEXT);

        const textSize = styles.text.size[cleverapps.resolution.mode];
        text.fitTo(textSize.width, textSize.height);

        text.setAlignment(styles.text);

        this.addChild(text);
    },

    onResize: function () {
        const styles = cleverapps.styles.HintView;

        const mode = cleverapps.resolution.mode;
        if (this.mode !== mode) {
            this.mode = mode;
            this.createText();
        }

        const textSize = styles.text.size[cleverapps.resolution.mode];

        this.bg.setContentSize(textSize.width + styles.bg.padding.x, textSize.height + styles.bg.padding.y);
        this.setContentSize(this.bg.getContentSize());

        if (this.showUpAction && !this.showUpAction.isDone()) {
            this.stopAction(this.showUpAction);
            delete this.showUpAction;
            this.setScale(1);
        }

        this.setAlignment({ x: { align: "center" }, y: { align: "top", dy: this.height } });
    },

    showUp: function (callback, silent) {
        if (silent) {
            this.setVisible(true);
            callback();
        } else {
            const styles = cleverapps.styles.HintView;
            const pos = this.getPosition();
            this.setVisible(true);
            this.setOpacity(0);
            this.setScale(0.5);
            this.setAlignment(styles.startPos);
            this.runAction(new cc.Sequence(
                new cc.DelayTime(0.9),
                new cc.CallFunc(callback)
            ));
            this.showUpAction = this.runAction(new cc.Sequence(
                cleverapps.effects.fireAction("scramble.subject"),
                new cc.Spawn(
                    new cc.FadeIn(0.4),
                    new cc.ScaleTo(0.4, 1.5)
                ),
                new cc.DelayTime(0.5),
                new cc.DelayTime(0.25),
                new cc.Spawn(
                    new cc.MoveTo(0.55, pos),
                    new cc.ScaleTo(0.55, 1)
                )
            ));
        }
    },

    hideAnimation: function () {
        this.setCascadeOpacityEnabledRecursively(true);
        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.5),
            new cc.FadeOut(0.5),
            new cc.Hide()
        ));
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    HINT_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.WHITE,
        shadow: cleverapps.styles.DECORATORS.IMAGE_FONT_SHADOW,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

cleverapps.styles.HintView = {
    startPos: {
        x: { align: "center" },
        y: { align: "center", dy: 150 }
    },

    bg: {
        x: { align: "center" },
        y: { align: "center" },
        padding: {
            x: 50,
            y: 0
        }
    },

    text: {
        dy: 1,
        size: [
            { width: 370, height: 44 },
            { width: 560, height: 62 },
            { width: 560, height: 62 }
        ],
        x: { align: "center" },
        y: { align: "center" }
    }
};